import styles from './timeline.module.scss';
import MaterialTimeline from '@mui/lab/Timeline';
import MaterialTimelineItem from '@mui/lab/TimelineItem';
import MaterialTimelineConnector from '@mui/lab/TimelineConnector';
import MaterialTimelineContent from '@mui/lab/TimelineContent';
import MaterialTimelineDot from '@mui/lab/TimelineDot';
import MaterialTimelineOppositeContent from '@mui/lab/TimelineOppositeContent';
import MaterialTimelineSeparator from '@mui/lab/TimelineSeparator';

/* eslint-disable-next-line */
export interface TimelineProps {
  children: any,
  // classes?: object,
  className?: string,
  position?: 'alternate' | 'left' | 'right',
  sx?: any
}

export interface TimelineItemProps {
  children?: any,
  // classes?: object,
  position?: 'left' | 'right',
  sx?: any
}

export interface TimelineConnectorProps {
  children?: any,
  // classes?: object,
  sx?: any
}

export interface TimelineContentProps {
  children?: any,
  // classes?: object,
  sx?: any,
  className?: string
}

export interface TimelineDotProps {
  children?: any,
  // classes?: object,
  color?: 'error' | 'grey' | 'info' | 'inherit' | 'primary' | 'secondary' | 'success' | 'warning',
  sx?: any,
  variant?: 'filled' | 'outlined'
}

export interface TimelineOppositeContentProps {
  children: any,
  // classes?: object,
  sx?: any
}

export interface TimelineSeparatorProps {
  children: any,
  // classes?: object,
  sx?: any
}

export function Timeline(props: TimelineProps) {
  return <>
    <MaterialTimeline
      position={props.position}
      sx={props.sx}
      className={props.className}>
      {props.children}
    </MaterialTimeline>
  </>
}

export function TimelineItem(props: TimelineItemProps) {
  return (
    <MaterialTimelineItem
      position={props.position}
      sx={props.sx}>
      {props.children}
    </MaterialTimelineItem>
  );
}

export function TimelineConnector(props: TimelineConnectorProps) {
  return (
    <MaterialTimelineConnector
      sx={props.sx}>
      {props.children}
    </MaterialTimelineConnector>
  );
}

export function TimelineContent(props: TimelineContentProps) {
  return (
    <MaterialTimelineContent
      sx={props.sx}
      className={props.className}>
      {props.children}
    </MaterialTimelineContent>
  );
}

export function TimelineDot(props: TimelineDotProps) {
  return (
    <MaterialTimelineDot
      color={props.color}
      sx={props.sx}
      variant={props.variant}>
      {props.children}
    </MaterialTimelineDot>
  );
}

export function TimelineOppositeContent(props: TimelineOppositeContentProps) {
  return (
    <MaterialTimelineOppositeContent
      sx={props.sx}>
      {props.children}
    </MaterialTimelineOppositeContent>
  );
}

export function TimelineSeparator(props: TimelineSeparatorProps) {
  return (
    <MaterialTimelineSeparator
      sx={props.sx}>
      {props.children}
    </MaterialTimelineSeparator>
  );
}

export default Timeline;